import * as Sentry from '@sentry/react'
import { env } from '../env'
import { sentryBeforeSend } from './sentry.beforeSend'

const allowedEnvironments = ['staging', 'rc', 'production']

if (allowedEnvironments.includes(env.nodeEnv as string)) {
  Sentry.init({
    dsn: `https://e3e5f5f05c87326574d8352767ae26ee@o4508914343542784.ingest.de.sentry.io/4508931264741456`,
    environment: env.nodeEnv,
    beforeSend: sentryBeforeSend,
  })
}
